import { Link } from 'react-router-dom';
import { categories as allCategories } from '@/mocks/categories';

interface BreadcrumbItem {
  label: string;
  to?: string;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
  categorySlug?: string;
}

export default function Breadcrumb({ items, categorySlug }: BreadcrumbProps) {
  const category = categorySlug
    ? allCategories.find((c) => c.slug === categorySlug)
    : undefined;

  const schemaItems = items.map((item, index) => ({
    '@type': 'ListItem' as const,
    position: index + 1,
    item: {
      '@id': item.to ? `https://www.51cg.com${item.to}` : undefined,
      name: item.label,
    },
  }));

  const breadcrumbSchema = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: schemaItems,
  };

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(breadcrumbSchema) }}
      />
      <nav aria-label="面包屑导航" className="flex items-center gap-2 text-sm text-foreground-500 flex-wrap">
        {items.map((item, index) => (
          <span key={index} className="flex items-center gap-2">
            {index > 0 && (
              <i className="ri-arrow-right-s-line text-xs text-foreground-400"></i>
            )}
            {item.to ? (
              <Link to={item.to} className="hover:text-primary-500 transition-colors cursor-pointer">
                {item.label}
              </Link>
            ) : (
              <span className="text-foreground-700 font-medium">{item.label}</span>
            )}
          </span>
        ))}
        {category && (
          <span className="flex items-center gap-2">
            <i className="ri-arrow-right-s-line text-xs text-foreground-400"></i>
            <span className="text-foreground-700 font-medium">{category.name}</span>
          </span>
        )}
      </nav>
    </>
  );
}